/**
 * https://www.pdftron.com/api/web/CoretViewer.html#setWatermark__anchor
 */
export default watermarkOptions => window.documentViewer.setWatermark(watermarkOptions);
